<template>
  <div>
    <v-card class="ma-2">
      <v-card-title class="primary--text">
        <v-layout align-center justify-space-between>
          <h3 class="mt-3 mb-3 ml-3 ml-0" color="primary">{{ $route.params.id }}</h3>
          <v-btn class="mr-3" color="primary" @click="refreshTable()">
            <v-icon left>mdi-reload</v-icon>
            {{ $t('common.reload') }}
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-container fluid grid-list-xl class="mt-0 pt-0">

        <v-layout row>
          <v-flex xs12>
            <div class="text-center">
              <v-pagination
                v-model="page"
                :length="length"
                :total-visible="7"
                @input="handlePageChange"
              ></v-pagination>
            </div>
            <v-data-table
              :headers="columns"
              :items="getCurrentDeviceAlarmData.data"
              :items-per-page="pageSize"
              :hide-default-footer="true"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ $t('alarm.at' + item.at) }}</td>
                  <td>{{ longDateMixin(item.ts) }}</td>
                  <td>{{ item.txt }}</td>
                  <td>
                    <v-layout v-if="item.pics" class="ma-0 pa-0">
                      <v-img v-for="snapshot in item.pics.split(',')" :key="snapshot" :src="snapshot" :aspect-ratio="16/9" width="200" class="ma-2" @click="openImage(snapshot)"></v-img>
                    </v-layout>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <div class="text-center">
              <v-pagination
                v-model="page"
                :length="length"
                :total-visible="7"
                @input="handlePageChange"
              ></v-pagination>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
    }
  },
  async mounted() {
    await this.refreshTable()
  },
  computed: {
    ...mapGetters(["getCurrentDeviceAlarmData", "getCurrentDevice"]),
    columns() {
      return [
        {
          text: this.$i18n.t("alarm.at"),
          value: "at"  
        },
        {
          text: this.$i18n.t("alarm.ts"),
          value: "ts"
        },
        {
          text: this.$i18n.t("alarm.txt"),
          value: "txt"
        },
        {
          text: this.$i18n.t("alarm.snapshot"),
          value: "pics"
        }
      ]
    },
    length() {
      return this.getCurrentDeviceAlarmData.totalItems != undefined ? Math.ceil(this.getCurrentDeviceAlarmData.totalItems / this.pageSize) : 1
    }
  },
  methods: {
    ...mapActions(["doLoadAlarmData"]),
    ...mapMutations(["mShowLongLoader", "mHideLongLoader"]),
    async handlePageChange(value) {
      this.$log.debug("handlePageChange: ", value)
      this.page = value;
      this.mShowLongLoader(this.$i18n.t("common.pleasewait"))
      await this.doLoadAlarmData({ device: this.getCurrentDevice.deviceId, page: this.page - 1, pageSize: this.pageSize })
      this.mHideLongLoader()
    },
    openImage(url) {
      const image_window = window.open("", "_blank")
      image_window.document.write(`
        <html>
          <head>
            <title>Alarm snapshot</title>
          </head>
          <body>
            <img src="${url}" alt="Example" height="100%" width="100%">
          </body>
        </html>
      `);
    },
    async refreshTable() {
      this.mShowLongLoader(this.$i18n.t("common.pleasewait"))
      await this.doLoadAlarmData({ device: this.getCurrentDevice.deviceId, page: this.page - 1, pageSize: this.pageSize })
      this.mHideLongLoader()
    }
  }
}
</script>

<style>

</style>